var _defs, _circle, _polygon, _polygon2, _polygon3, _polygon4, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg72Ms8(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_7",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#03142a;}.cls-2,.cls-3{fill:#fff;}.cls-3{fill-rule:evenodd;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 16,
    cy: 16,
    r: 16
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "19.84 9.32 19.84 10.32 21.68 10.32 21.68 12.16 22.68 12.16 23.68 12.16 23.68 8.32 19.84 8.32 19.84 9.32"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "23.68 23.68 23.68 19.84 22.68 19.84 21.68 19.84 21.68 21.68 19.84 21.68 19.84 22.68 19.84 23.68 23.68 23.68"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "9.32 12.16 10.32 12.16 10.32 10.32 12.16 10.32 12.16 9.32 12.16 8.32 8.32 8.32 8.32 12.16 9.32 12.16"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "12.16 22.68 12.16 21.68 10.32 21.68 10.32 19.84 9.32 19.84 8.32 19.84 8.32 23.68 12.16 23.68 12.16 22.68"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.71,12.64v.88c0,.4-.32,.73-.71,.73s-.71-.33-.71-.73v-.15h-1.58s.01,.04,.01,.06v5.48h.71c.32,0,.57,.26,.57,.58s-.26,.58-.57,.58h-2.86c-.32,0-.57-.26-.57-.58s.26-.58,.57-.58h.71v-5.48s0-.04,.01-.06h-1.58v.15c0,.4-.32,.73-.71,.73s-.71-.33-.71-.73v-.88c0-.4,.32-.73,.71-.73h6c.39,0,.71,.33,.71,.73Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg72Ms8);
export default __webpack_public_path__ + "static/media/72-ms-8.319a5ff8a725ae61d4956bcfb4f70429.svg";
export { ForwardRef as ReactComponent };